
import { AuthenticationResult, EventType, PublicClientApplication } from '@azure/msal-browser'

import { msalConfig } from './config/msalConfig'

export const msalInstance = new PublicClientApplication(msalConfig)

const accounts = msalInstance.getAllAccounts()
if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
}

msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_FAILURE) {
        console.dir(event)
    }

    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const payload = event.payload as AuthenticationResult
        const account = payload.account

        msalInstance.setActiveAccount(account)
    }
})
